<template>
  <compose view-model.bind="path" model.bind="data"></compose>
</template>
